import HttpRequest from "@api/httpRequest";

const getUrl = (): string => {
  return `/clients`;
};

function api() {
  return {
    getList: () => {
      return HttpRequest.get(getUrl());
    },
  };
}

export default api();
